<template>
    <div class="shop-desc-box" id="shop-desc">
      <img src="../../assets/images/back-white.png" alt="" v-if="!showtabs && $route.path === '/shop-desc' && ($store.state.userAgent === 'Mobile' ||
      $store.state.userAgent === 'PC')" class="back-img" width="30" height="30" @click="goBack">
      <tabs :tabs="['','产品','详情','']" ref="tabs" style="top: 0;" :style="opacityStyle" v-else-if="showtabs" />
      <van-swipe class="my-swipe" indicator-color="white" lazy-render v-if="$store.state.userAgent === 'Mobile'">
        <van-swipe-item v-for="(imgurl, i) in swipeImgUrl" :key="i">
          <div v-lazy-container="{
               selector: 'img', error: require('../../assets/images/default-shop-desc-swiper.png'),
               loading:require('../../assets/images/default-shop-desc-swiper.png') }">
            <img :data-src="imgurl" alt="" width="100%" height="100%" style="min-height:375px;"  @click="handleMainImgClick(imgurl)">
          </div>
        </van-swipe-item>
      </van-swipe>
      <van-swipe class="my-swipe" indicator-color="white" lazy-render autoplay="3000" v-else>
        <van-swipe-item v-for="(imgurl, i) in swipeImgUrl" :key="i">
          <div v-lazy-container="{
               selector: 'img', error: require('../../assets/images/625_625_bg.png'),
               loading:require('../../assets/images/default-shop-desc-swiper.png') }">
            <img :data-src="imgurl" alt="" width="100%" height="100%" style="min-height:375px;">
          </div>
        </van-swipe-item>
      </van-swipe>
      <div class="title-box">
        <!-- <div class="price"><span v-show="goods.originalCost">￥</span>{{ goods.minPrice }}</div> -->
        <div class="text">{{ goods.title }}</div>
      </div>
      <div class="shop-card">
        <img :src="logo" alt="" width="50" height="50">
        <div class="text">
          <div class="title">{{ shopName }}</div>
          <div style="display:flex;">
            <div class="span">品质信赖</div>
            <!-- <div class="span">品类多样</div> -->
            <div class="span">无忧服务</div>
          </div>
        </div>
      </div>
      <!-- <div class="description" id="description" ref="description">
          <img v-lazy="url" alt="" v-for="(url, i) in descImgUrl" :key="i" width="100%" @click="handleDescImgClick(url)">
      </div> -->
      <div class="collapse">
        <van-collapse v-model="activeName" @change="collapseChange">
          <van-collapse-item title="参数规格" name="1">
            <div class="size-desc-row">
              <div v-for="(label, i) in labelList" :key="i" @click="selectLabel(label.id)">
                <div :class="[label.isSelected ? 'label-selected':'label']" v-show="label && label.sizeDesc && label.sizeDesc.length > 0">
                  <div>{{ label.text }}</div>
                </div>
              </div>
            </div>
            <div class="size-desc">
              <div class="row" v-show="labelListItem.sizeDesc && labelListItem.sizeDesc.length === 0">
                <div class="label-none">暂无参数</div>
              </div>
              <div class="row" v-for="(sizeDesc, j) in labelListItem.sizeDesc" :key="j">
                <div class="label">{{ sizeDesc.labelName }}</div><div class="text">{{ sizeDesc.value }}</div>
              </div>
            </div>
          </van-collapse-item>
          <van-collapse-item title="图看详情" name="2">
            <div class="description" id="description" ref="description">
                <img v-lazy="url" alt="" v-for="(url, i) in descImgUrl" :key="i" width="100%" @click="handleDescImgClick(url)">
            </div>
          </van-collapse-item>
          <van-collapse-item title="产品描述" name="3" v-show="goods.desc && goods.desc.length > 0">
            <div class="goods-desc">
              <div v-html="goodsDescHtml"></div>
            </div>
          </van-collapse-item>
          <!-- <van-collapse-item title="价格说明" name="3">
            <div class="price-reminder">
              <div>划线价格：指商品的专柜价、吊牌价、正品零售价、厂家指导价或该商品曾经展示过的销售价等，并非原价，仅供参考。</div>
              <div class="middle-row">未划线价格：指商品的销售价，是您最终决定是否购买商品的依据。</div>
              <div>折扣：页面显示的“折扣”为非划线价格与划线价格的对比，该对比值仅供您参考，不作为计算非划线价格的依据。</div>
            </div>
          </van-collapse-item> -->
          <!-- <van-collapse-item title="消费提醒" name="4">
            <div class="buy-reminder">
              <div>请严格按照使用说明书要求进行使用，清洗时注意断电，避免发生烫伤等意外，产品放置在儿童触摸不到的地方，同时养成用完就断开电源、拔下插头的良好习惯。</div>
            </div>
          </van-collapse-item> -->
        </van-collapse>
      </div>
      <!-- <div ref="recommend">
        <div>推荐</div>
        <div>敬请期待</div>
      </div> -->
      <buy @createOrder="createOrder" :isShortage="isShortage" :showAddCartButton="true" :cartAmount="$store.state.cartAmount" v-show="!showPopup"/>
      <van-popup v-model="showPopup" position="bottom" round :style="'max-height: 80%; max-width:750px'">
        <div class="title-text">
          <div class="text">款式</div>
          <div class="img"><img :src="selectSizeImg" alt="" width="75" height="75" @click="handleImgClick"></div>
        </div>
        <div class="order-details">
          <div class="type">
            <div :class="[option.isSelected ? 'option-selected':'option']" v-for="(option) in options" :key="option.id" @click="selectOption(option.id)">
              <div style="display:flex;flex-wrap:nowrap;">
                <div class="label">
                  <div class="img"><img :src="option.sizeImgUrl" alt="" width="30" height="30"></div>
                  <div class="text">{{ option.text }}</div>
                </div>
                <span v-show="option.amount === 0" class="mark">缺货</span>
              </div>
            </div>
          </div>
          <div class="amount">
            <!-- 助手不选数量 -->
            <!-- <div class="title">
              <span>数量</span>
              <van-stepper v-model="orderInfo.amount" @change="changeAmount" input-width="40px" button-size="32px"/>
            </div> -->
          </div>
        </div>
      </van-popup>
      <div class="button-row" v-show="showPopup">
        <div class="button-buy-cart" @click="makePhoneCalls" v-if="buttonType === 'addCart'">联系客服</div>
        <!-- <div class="button-buy-cart" @click="addCart" v-if="buttonType === 'addCart'">加入购物车</div> -->
        <div class="button-buy" @click="submitOrder" v-else>购买</div>
      </div>
      <go-page-confirm v-show="showGoPageConfirm" @handleClick="handleDialogClick"/>
      <!-- 图片预览 -->
      <van-image-preview v-model="showSizeImg" :images="[selectSizeImg]" @change="onChange">
        <template v-slot:index>{{ }}</template>
        <!-- <template v-slot:index>第{{ index + 1 }}页</template> -->
      </van-image-preview>
      <van-image-preview v-model="showDescImg" :images="[selectDescImg]" @change="onDescChange">
        <template v-slot:index>{{ }}</template>
        <!-- <template v-slot:index>第{{ index + 1 }}页</template> -->
      </van-image-preview>
      <van-image-preview v-model="showMainImg" :images="[selectMainImg]" @change="onMainChange">
        <template v-slot:index>{{ }}</template>
        <!-- <template v-slot:index>第{{ index + 1 }}页</template> -->
      </van-image-preview>
      <!-- <div class="size-image-box" v-show="showSizeImg">
        <div class="row">
          <img src="../../assets/images/false-white.png" alt="" @click="closeImg" width="30" height="30">
        </div>
        <div class="img">
          <img :src="selectSizeImg" alt="" width="100%" height="100%" @click="handleImgClick">
        </div>
      </div> -->
      <MiniProgramGuide :path="'/pages/goods/detail/index?gid=' + $route.query.gid" />
    </div>
</template>

<script>
import Buy from '../../components/footer/Buy.vue'
import { queryGoodsById, createCart, queryCartGoodsTotalAmount, wxSdk, queryIPLocation, getIP, createUserStas } from '@/api/api'
import Tabs from '../../components/tabs/index.vue'
const seo = require('../../../config/index')
import { getopenIdByCode, isWeiXin, getBaseInfos } from '@/utils/index';
import wx from "weixin-js-sdk";
import goPageConfirm from '../../components/dialog/GoPageConfirm.vue'
import { ImagePreview } from 'vant'
import MiniProgramGuide from '@/components/MiniProgramGuide.vue'

export default {
  name: 'Description',
  components: {
    Buy,
    Tabs,
    [ImagePreview.Component.name]: ImagePreview.Component,
    goPageConfirm,
    MiniProgramGuide
  },
  created(){
    this.handleIp()
    // this.initOpenId()
  },
  mounted(){
    this.$bus.$on('changeTaaab', this.changeTab)
    window.addEventListener('scroll',this.handleScroll);
    // if(this.$store.state.userAgent !== 'Mobile'){
    //     document.getElementById("shop-desc").style.cssText= 'margin-top: 58px';
    // }
    this.init()
  },
  deactivated(){
    window.removeEventListener('scroll',this.handleScroll);
    document.querySelector('body').style.overflow = '' // 恢复滚动
  },
  destroyed(){
    document.querySelector('body').style.overflow = '' // 恢复滚动
  },
  data:()=>{
    return {
      swipeImgUrl:[require('../../assets/images/default-shop-desc-swiper.png')],
      descImgUrl:[
        require('../../assets/images/default-shop-desc-swiper.png'),
      ],
      mainListImgUrl:'',
      options:[{
        id:'1',
        text: '默认',
        price: 99,
        isSelected: false
      }],
      labelList:[{
        id:'1',
        text: '默认',
        price: 99,
        isSelected: false
      }],
      labelListItem:{},
      logo: seo.config.logo,
      goods:{},
      showGoPageConfirm:false,
      orderInfo:{
        title:'', // 标题
        amount: 1, // 数量
        type: '', // 款式
        originalCost: 0, // 单件的原价
        discount: 0, // 折扣
        totalPrice: 0, // 总价
        expressCharge: 0, // 运费
        discountPrice: 0, // 享受的优惠价格
        finalPayPrice: 0, // 最终支付价格
        imgUrl: '', // 商品图片
      },
      showPopup: false,
      activeName: ['1','2','3'],
      showtabs: false,
      opacityStyle:{
        opacity:0
      },
      shopName: seo.config.shopName,
      appName: seo.config.appName,
      isShortage: false,
      buttonType: '',
      isLogin: localStorage.getItem('token') ? true : false,
      servicePhone: seo.config.servicePhone,
      goodsDescHtml: null,
      selectSizeImg: '', // 选中的款式图片
      selectDescImg: '', // 选中的详情图片
      selectMainImg: '', // 选中的主图图片
      showSizeImg:false,
      showDescImg:false,
      showMainImg:false,
    }
  },
  methods:{
    async init(){
      await this.getData()
      await this.wxShare()
    },
    async getData(){
      queryGoodsById({ gid: this.$route.query.gid }).then((res)=>{
        if(Object.keys(res.data.data).length > 0){
          this.swipeImgUrl = res.data.data.mini_main_img_url.split(',')
          this.descImgUrl = res.data.data.mini_desc_img_url.split(',')
          this.mainListImgUrl = res.data.data.mini_main_list_img_url
          this.goods.title = res.data.data.title
          this.goods.originalCost = res.data.data.price
          this.goods.minPrice = res.data.data.minPrice
          this.goods.maxPrice = res.data.data.maxPrice
          this.goods.desc = res.data.data.desc
          this.goodsDescHtml = res.data.data.desc.replace(/\n/g, '<br><br>')
          this.goods.sizeDesc = res.data.data.sizeDesc
          this.isShortage = res.data.data.onSaleTotal === 0 ? true : false
          this.options.length = 0
          this.labelList.length = 0
          if(res.data.data.options.length !== 0){
              this.options = res.data.data.options
              this.labelList = res.data.data.labelList
              this.selectOption('0')
              this.selectLabel('0')
              this.selectSizeImg = res.data.data.options[0].sizeImgUrl.length > 0 ? res.data.data.options[0].sizeImgUrl : require('../../assets/images/no-image.png')
              // 购物车跳转过来
              if(sessionStorage.getItem('goodDescInfo')){
                let goodDescInfo = JSON.parse(sessionStorage.getItem('goodDescInfo'))
                sessionStorage.removeItem('goodDescInfo')
                this.orderInfo.amount = goodDescInfo.amount
                this.options = this.options.map(option => ({ ...option, isSelected: false }));
                let index = this.options.findIndex(option => option.text === goodDescInfo.type);
                if (index !== -1) {
                  this.options[index].isSelected = true;
                }
              }
          } else {
              let temp = {}
              let str = '默认'
              temp.id = '1'
              temp.text = str
              temp.price = res.data.data.price
              temp.isSelected = true
              this.options.push(temp)
              this.labelList.push(temp)
          }
          // seo
          document.title = res.data.data.title + '-' + seo.config.appName
          let keywords = '衣柜灯,酒柜灯,橱柜灯,筒灯,小夜灯,壁灯,露营灯,无主灯,感应灯,射灯'
          let description = '在这里选购全网最精致,最实用的灯具产品,入住新家不能没有他,包括但不限于衣柜灯,酒柜灯,橱柜灯,筒灯,小夜灯,壁灯,露营灯,无主灯,感应灯,射灯'
          document.querySelector('meta[name="keywords"]').setAttribute('content', keywords)
          document.querySelector('meta[name="description"]').setAttribute('content', description)
        } else {
          this.showGoPageConfirm = true
          document.querySelector('body').style.overflow = 'hidden' // 阻止弹窗背景滚动
        }
      })
    },
    makePhoneCalls(){
      window.location.href = 'tel:' + this.servicePhone;
    },
    createOrder(type){
      if(!this.isShortage){
        this.buttonType = type
        this.showPopup = !this.showPopup
      }
    },
    // closeImg(){
    //   this.showSizeImg = false
    // },
    selectOption(id){
      let tempArr = []
      let optTemp = this.options.filter(opt=>{
        return opt.id === id
      })
      if(optTemp[0].amount > 0){
        this.options.forEach((opt)=>{
          let temp = {}
          temp.id = opt.id
          temp.text = opt.text
          temp.amount = opt.amount
          temp.price = opt.price
          temp.sizeImgUrl = opt.sizeImgUrl && opt.sizeImgUrl.length > 0 ? opt.sizeImgUrl : require('../../assets/images/no-image.png')
          if(id === opt.id){
            temp.isSelected = true
            this.orderInfo.type = opt.text
            this.orderInfo.originalCost = opt.price
            this.selectSizeImg = opt.sizeImgUrl && opt.sizeImgUrl.length > 0 ? opt.sizeImgUrl : require('../../assets/images/no-image.png')
          } else {
            temp.isSelected = false
          }
          tempArr.push(temp)
        })
        this.options = tempArr
      }
    },
    selectLabel(id){
      let tempArr = []
      this.labelList.forEach((label)=>{
        let temp = {}
        temp.id = label.id
        temp.text = label.text
        temp.sizeDesc = label.sizeDesc
        temp.sizeImgUrl = label.sizeImgUrl
        if(id === label.id){
          this.labelListItem = label
          temp.isSelected = true
        } else {
          temp.isSelected = false
        }
        tempArr.push(temp)
      })
      this.labelList = tempArr
    },
    changeAmount(val){
      this.orderInfo.amount = Number(val)
    },
    submitOrder(){
      // 默认选第一款
      let lists = []
      this.orderInfo.type = this.orderInfo.type ? this.orderInfo.type : this.options[0].text
      this.orderInfo.originalCost = this.orderInfo.originalCost ? this.orderInfo.originalCost : this.options[0].price
      if(this.orderInfo.type){
        if(this.isLogin){
          this.orderInfo.gid = this.$route.query.gid
          this.orderInfo.title = this.goods.title
          this.orderInfo.imgUrl = this.mainListImgUrl
          this.orderInfo.totalPrice = this.orderInfo.amount * 100 * this.orderInfo.originalCost / 100
          this.orderInfo.finalPayPrice = this.orderInfo.totalPrice
          this.orderInfo.shop = seo.config.shopName
          lists.push(this.orderInfo)
          sessionStorage.setItem('lists', JSON.stringify(lists))
          this.$router.push({ path:'/pay', query:{ oid: new Date().getTime(), gid: this.$route.query.gid } })
        } else {
          sessionStorage.setItem('fromPath', '/shop-desc?gid=33')
          this.$router.push({ name:'Login', params:{ text:'选商品' } })
        }
      } else {
        this.$notify({
              message: '请选择款式',
              duration: 1000,
              background: '#ec745b'
        })
      }
    },
    // 联系客服
    showServiceDialog(){

    },
    // 加入购物车
    addCart(){
        if(this.isLogin){
          let goodInfo = {}
          goodInfo.gid = Number(this.$route.query.gid)
          goodInfo.imgUrl = this.mainListImgUrl
          goodInfo.title = this.goods.title
          goodInfo.type = this.orderInfo.type ? this.orderInfo.type : this.options[0].text
          goodInfo.amount = this.orderInfo.amount
          goodInfo.price = this.orderInfo.originalCost ? this.orderInfo.originalCost : this.options[0].price
          goodInfo.uid = Number(JSON.parse(localStorage.getItem('userInfo'))[0].uid)
          goodInfo.shop = seo.config.shopName
          createCart({ goodInfo: goodInfo }).then(()=>{
            this.showPopup = !this.showPopup
            this.orderInfo.amount = 1 // 默认
            this.selectOption('0')
            // 重新获取购物车数量
            queryCartGoodsTotalAmount({ uid: goodInfo.uid }).then((res)=>{
              this.$store.commit('Set_CartAmount_State', res.data.total_amount)
            })
          })
        } else {
          sessionStorage.setItem('fromPath', '/shop-desc?gid=33')
          this.$router.push({ name:'Login', params:{ text:'选商品' } })
        }
    },
    getAddress(){
      
    },
    goBack(){
      let fromPath = sessionStorage.getItem('fromPath')
      if(fromPath && fromPath === '/pay'){
        this.$router.push('/')
        sessionStorage.removeItem('fromPath')
      } else {
        if (window.history.state) { // 有上一页则返回
          this.$router.back()
        } else { // 没有上一页则返回到首页
          this.$router.push('/')
        }
      }
    },
    collapseChange(){

    },
    handleDialogClick(){
      this.$router.push('/')
    },
    onChange(index) {
      this.index = index;
    },
    onDescChange(index) {
      this.index = index;
    },
    onMainChange(index) {
      this.index = index;
    },
    handleMainImgClick(url){
      this.selectMainImg = url
      this.showMainImg = true
    },
    handleImgClick(){
      this.showSizeImg = true
    },
    handleDescImgClick(url){
      this.selectDescImg = url
      this.showDescImg = true
    },
    handleScroll(){
        const top = document.documentElement.scrollTop ||  document.body.scrollTop;
        if(top < 100){
            this.showtabs = false;
            let opacity = top / 100;
            opacity = opacity > 1 ? 1 : opacity;    
            this.opacityStyle = { opacity };
        }else{
            this.showtabs = true;
            let opacity = 1
            this.opacityStyle = { opacity };
        }
        let distanceToTop = this.$refs.description ? this.$refs.description.offsetTop : 0
        if(this.$refs.tabs){
          if(top >= distanceToTop - 45){ // 滚动条距离顶部位置 // 详情元素的绝对位置
            this.$refs.tabs.changeTab(1, true)
          } else {
            this.$refs.tabs.changeTab(0, true)
          }
        }
    },
    changeTab(id){
      if(id === 0){
        document.body.scrollTop && document.body.scrollTo({top: 0, behavior: 'smooth'})
        document.documentElement.scrollTop && document.documentElement.scrollTo({top: 0, behavior: 'smooth'})
      } else if(id === 1 && this.$route.path.includes('/shop-desc')){
        let distanceToTop = this.$refs.description.offsetTop - 45 // 绝对位置和tabs的height值
        window.scrollTo({
          top: distanceToTop,
          behavior: "smooth"
        });
      } else if(id === 2){
        let distanceToTop = this.$refs.recommend.offsetTop -45 // 绝对位置和tabs的height值
        window.scrollTo({
          top: distanceToTop,
          behavior: "smooth"
        });
      }
    },
    handleIp(){
      getIP({}).then((res)=>{
        queryIPLocation({ ip: res.data.data }).then((result)=>{
          let resData = result.data.data
          if(resData.info === 'OK' && resData.city.length > 0){
            let params = {}
            if(String(resData.province) === String(resData.city)){
              params.area = resData.city
            } else {
              params.area = resData.province + '-' + resData.city
            }
            params.ip = res.data.data
            createUserStas(params)
          }
        })
      })
    },
    initOpenId(){
      if(isWeiXin()){
          if(!window.location.href.includes('code=')){
            getBaseInfos('')
          } else {
            getopenIdByCode()
          }
      }
    },
    async wxShare(){
        let url = seo.config.wxConfig.goodsPage.link + this.$route.fullPath
        wxSdk({ url:url }).then(res=>{
          let my = this
          let title =  seo.config.firstFooterName + my.goods.title
          let shareImg = seo.config.homeUrl + my.swipeImgUrl[0]
          let shareDesc = my.goods.desc && my.goods.desc.length > 0 ? my.goods.desc : seo.config.wxConfig.goodsPage.desc
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: seo.config.wxConfig.appId, // 必填，公众号的唯一标识
            timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.data.signature,// 必填，签名
            jsApiList: ['checkJsApi', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage','onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone'], // 必填，需要使用的JS接口列表
            openTagList: ['wx-open-launch-weapp']
          });
          wx.ready(function () {
            wx.checkJsApi({
                jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage','onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone'], // 必填，需要使用的JS接口列表
                success: function(res) {
                // “分享给朋友”及“分享到QQ”
                if (res.checkResult.updateAppMessageShareData || res.checkResult.onMenuShareAppMessage) {
                    wx.updateAppMessageShareData({ 
                      title: title, // 分享标题
                      desc: shareDesc, // 分享描述
                      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                      imgUrl: shareImg, // 分享图标
                      success: function () {
                          // 设置成功
                      }
                    })
                }
                // “分享到朋友圈”及“分享到 QQ 空间”
                if(res.checkResult.updateTimelineShareData || res.checkResult.onMenuShareTimeline){
                    wx.updateTimelineShareData({ 
                      title: title, // 分享标题
                      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                      imgUrl: shareImg, // 分享图标
                      success: function () {
                          // 设置成功
                      }
                    })
                }
            }})
          })
        })
    },
  },
}
</script>

<style scoped lang="scss">
.shop-desc-box {
  min-height: 100vh;
  padding-bottom: calc(85px + constant(safe-area-inset-bottom));
  padding-bottom: calc(85px + env(safe-area-inset-bottom));
  position: relative;
}
.size-image-box {
  position: fixed;
  z-index: 10000;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  .row {
    position: fixed;
    z-index: 10000;
    top: 15px;
    left: 15px;
    font-size: 30px;
    color: #fff;
    text-align: left;
  }
  .img {
    // touch-action: auto;
  }
}
.my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    text-align: center;
    background-color: #f3f3f3;
}
.title-box {
  background: #fff;
  border-radius: 5px;
  margin: 5px;
  text-align: left;
  padding: 15px 15px 20px;
  font-size: 20px;
  min-height: 60px;
  .price {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 5px;
    min-height: 27px;
    span {
      font-size: 14px;
    }
  }
  .text {
    min-height: 55px;
    display: flex;
    align-items: center;
  }
}
.shop-card {
  display: flex;
  align-items: center;
  background: #fff;
  margin: 10px 5px;
  padding: 15px 15px;
  border-radius: 5px;
  img {
    border-radius: 5px;
  }
  .text {
    margin: 0 10px 0 15px;
    text-align: left;
    font-size: 18px;
    .span {
      font-size: 14px;
      background: #eee;
      color: rgba(0,0,0,0.6);
      margin: 5px 6px 0px 0px;
      padding: 2px 10px;
      border-radius: 2px;
    }
  }
}
.tabs {
  display: flex;
  background: #fff;
  height: 40px;
  align-items: center;
  justify-content: space-between;
  padding: 0 25%;
  border-radius: 5px;
  margin: 0 5px;
  .tab {
    font-size: 16px;
  }
}
.description {
  margin: -5px -10px 0;
  img {
    margin: -2px 0;
  }
}
.collapse {
  margin: 0 5px;
  .size-desc-row {
    display: flex;
    overflow-x: auto;
    margin-left: -5px;
    .label {
      background: #f3f3f3;
      padding: 3px 10px;
      border-radius: 10px;
      color: rgba(0,0,0,0.6);
      margin: 5px 5px;
      display: flex;
      white-space: nowrap;
    }
    .label-selected {
      background: #FFFAAA;
      padding: 3px 10px;
      border-radius: 10px;
      color: rgba(0,0,0,0.6);
      margin: 5px 5px;
      display: flex;
      white-space: nowrap;
    }
    -ms-overflow-style: none; /* IE和Edge */
    scrollbar-width: none; /* Firefox */
  }
  .size-desc-row::-webkit-scrollbar {
    display: none; /* Webkit内核浏览器（Chrome、Safari） */
  }
  .size-desc {
    text-align: left;
    .row {
      display: flex;
      font-size: 14px;
      color: #424242;
      margin: 15px 0;
      .label {
        width: 100px;
      }
      .label-none {
        color: grey;
      }
      .text {
        flex: 1;
      }
    }
    .row-middle {
      display: flex;
      margin: 10px 0;
      .label {
        width: 100px;
      }
      .text {
        flex: 1;
      }
    }
  }
  .goods-desc {
    text-align: left;
    padding: 10px 0 20px;
  }
  .buy-reminder {
    text-align: left;
  }
}
.title-text {
  position: fixed;
  max-width: 750px;
  margin: 0 auto;
  z-index: 9999;
  left: 0px;
  background: #fff;
  border-radius: 25px;
  text-align: left;
  right: 0;
  .text {
    padding: 25px 0 10px 20px;
  }
  .img {
    img {
      border-radius: 0px;
    }
    padding: 5px 0 10px 30px;
  }
}
.order-details {
  text-align: left;
  .type {
    padding: 150px 25px 0;
    .option {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin: 10px 0;
      cursor: pointer;
      .label {
        display: flex;
        align-items: center;
        padding: 7px 15px;
        border-radius: 5px;
        margin: 0 5px;
        word-break: break-all;
        background: #f3f3f3;
        border: 1px rgba(0,0,0,0.03) solid;
        .img {
          display: flex;
          align-items: center;
        }
        .text {
          padding: 0 0 0 10px;
        }
      }
      .mark {
        font-size: 12px;
        color: #fc5f10;
      }
    }
    .option-selected {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin: 10px 0;
      cursor: pointer;
      .label {
        display: flex;
        align-items: center;
        padding: 7px 15px;
        border-radius: 5px;
        margin: 0 5px;
        word-break: break-all;
        background: #FFFAAA;
        border: 1px rgba(0,0,0,0.03) solid;
        .img {
          display: flex;
          align-items: center;
        }
        .text {
          padding: 0 0 0 10px;
        }
      }
    }
  }
  .amount {
    padding: 10px 25px 65px;
    padding-bottom: calc(65px + constant(safe-area-inset-bottom));
    padding-bottom: calc(65px + env(safe-area-inset-bottom));
    .title {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }
  }
}
.button-row {
  position: fixed;
  bottom: 0px;
  right: 0;
  z-index: 9998;
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  padding-bottom: calc(10px + constant(safe-area-inset-bottom));
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  background: #fff;
  box-sizing: border-box;
  max-width: 750px;
  margin: 0 auto;
  left: 0;
  .button-buy {
      width: 160px;
      height: 38px;
      display: flex;
      line-height: 30px;
      border-radius: 30px;
      align-items: center;
      font-size: 14px;
      color: #fff;
      background: #fc5f10;
      justify-content: center;
      border: 1px solid #fc5f10;
      cursor: pointer;
  }
  .button-buy-cart {
    width: 160px;
    height: 38px;
    display: flex;
    margin: 0 10px;
    line-height: 30px;
    border-radius: 30px;
    align-items: center;
    font-size: 14px;
    color: #fff;
    background: #fbbc05;
    justify-content: center;
    border: 1px solid #fbbc05;
  }
}
.sizeParams {
  background: #fff;
  text-align: left;
  margin: 0 5px;
  font-size: 14px;
}
.priceDesc {
  background: #fff;
  text-align: left;
  margin: 0 5px;
  font-size: 14px;
}
.back-img {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1101;
  background: rgba(250, 250, 250, 0.5);
  border-radius: 50%;
  width: 35px;
  height: 35px;
  padding: 6px 4px;
  box-sizing: border-box;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
::v-deep .van-cell__title, .van-cell__value {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: left;
}
::v-deep .van-popup--bottom {
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    margin: 0 auto;
}
::v-deep .van-image-preview__overlay {
    background-color: rgba(0,0,0,1);
}
::v-deep .van-image-preview__swipe {
    height: 100%;
    background-color: rgba(0,0,0,1);
}
::v-deep .van-image-preview {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999 !important;
}
</style>